<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-body tab2-card">
                    <form [formGroup]="suppliersFuiForm" class="needs-validation" novalidate>
                        <div class="form-group row">
                            <div class="col-xl-4 col-md-4">
                                <label>{{cui}}</label>
                                <input class="form-control" formControlName="cui" type="text" />
                            </div>
                            <div class="col-xl-4 col-md-4">
                                <label>{{supplierName}}</label>
                                <input class="form-control" type="text" formControlName="supplierName" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-xl-4 col-md-4">
                                <label class="bold">{{decision}}</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-xl-4 col-md-4">
                                <label>{{decisionNumber}}</label>
                                <input [ngClass]="onDisplayRequiredField('statusDecisionNumber')" class="form-control"
                                    formControlName="statusDecisionNumber" type="text" />
                            </div>
                        </div>
                        <ng-container *ngIf="!isIncativareFui">
                            <div class="form-group row">
                                <div class="col-xl-4 col-md-4">
                                    <label [ngClass]="onDisplayRequiredField('supplierType')">{{markAs}}</label>
                                    <label class="d-block">
                                        <input class="radio_animated" id="supplierType" formControlName="supplierType"
                                            [value]="nominated" type="radio">
                                        {{supplierOfLastResortNominated}}
                                    </label>
                                    <ng-container *ngIf="this.actionType !== 'nominalizeazaFui'">
                                        <label class="d-block">
                                            <input class="radio_animated" id="supplierType"
                                                formControlName="supplierType" [value]="designated" type="radio">
                                            {{supplierOfLastResortDesignated}}
                                        </label>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isIncativareFui">
                            <div class="form-group row">
                                <div class="col-xl-4 col-md-4">
                                    <label class="d-block" *ngIf="(this.supplier.fuiTypeElectricityValue === nominated && this.isElectricity) ||
                                    (this.supplier.fuiTypeGasValue === nominated && isGas)">
                                        <input class="radio_animated" id="supplierType" formControlName="supplierType"
                                            [value]="inactiveNominated" type="radio">
                                        {{inactivateNominated}}
                                    </label>
                                    <label class="d-block">
                                        <input class="radio_animated" id="supplierType" formControlName="supplierType"
                                            [value]="'invalidateFui'" type="radio">
                                        {{inactivateFui}}
                                    </label>
                                </div>
                            </div>
                        </ng-container>
                        <div class="form-group row">
                            <div class="col-xl-4 col-md-4">
                                <ng-container *ngIf="!isIncativareFui">
                                    <label>{{startDate}}</label>
                                </ng-container>
                                <ng-container *ngIf="isIncativareFui">
                                    <label>{{inactivationDate}}</label>
                                </ng-container>
                                <input [ngClass]="onDisplayRequiredField('startDate')"
                                    [min]="minDate | date:'yyyy-MM-dd'" class="form-control" type="date"
                                    (change)="onStartDateChanged($event)" formControlName="startDate"
                                    onkeydown="return false" />
                            </div>
                            <div class="col-xl-4 col-md-4"
                                *ngIf="this.suppliersFuiForm.get('supplierType').value === nominated">
                                <label>{{endDate}}</label>
                                <input [ngClass]="onDisplayRequiredField('endDate')" [min]="minDate | date:'yyyy-MM-dd'"
                                    (change)="onEndDateChanged($event)" class="form-control" type="date"
                                    formControlName="endDate" onkeydown="return false" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-xl-4 col-md-4">
                                <label>{{reason}}</label>
                                <textarea formControlName="statusChangeReason" class="form-control" rows="4"></textarea>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer row pull-right">
                        <button type="button" class="btn btn-primary button-margin" (click)="onCancel()">
                            {{cancelButtonText}}
                        </button>
                        <button style="margin-left: 24px;" type="button" class="btn btn-primary button-margin"
                            (click)="onChangeFuiStatus()">
                            {{saveButtonText}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>